module.exports = __webpack_public_path__ + "static/Testimonial3-ada9f6ba4b0ec1ec163147b2116fa27b.jpg";